import React, {useState} from 'react'
import * as Yup from 'yup'
import {useFormik} from 'formik'
//constants
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {fetchAsyncupdateProfileDetails} from '../UserPages/accounts/Overview/OverviewSlice/UpdateProfileSlice'
import {
  getAllUserDetails,
  fetchAsyncUserDetails,
} from '../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {getUserData} from '../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'

const ProfileDetails: React.FC = () => {
  let defaultimage = toAbsoluteUrl('/media/avatars/blank.png')
  const Currency = useSelector((state: any) => state?.userDetails?.userDetails?.data?.currency)
  const role = useSelector(getUserData)?.data?.user?.role
  const user = useSelector(getUserData)?.data?.user

  const [avatar, setAvatar] = useState<any>(defaultimage)
  const userValues = useSelector(getAllUserDetails)

  const initialValues: any = {
    mobile: userValues?.mobile || '',
    // avatar: '/Cellcast-reactjs/media/avatars/300-1.jpg',
    //rest for user
    firstName: userValues?.firstName || '',
    lastName: userValues?.lastName || '',
    company: userValues?.companyName || '',
    contactPhone: userValues?.mobile || '',
    companySite: userValues?.companyWebsite || '',
    country: userValues?.country || '',
    language: userValues?.language || '',
    timeZone: userValues?.timeZone || '',
    currency: userValues?.currency || '',
    communications: {
      email: userValues?.communication.email,
      phone: userValues?.communication.phone,
    },
    defaultGateway: {
      sms: userValues?.defaultGateway?.sms,
      mms: userValues?.defaultGateway?.mms
    },
    allowMarketing: userValues?.allowMarketing,
    emailCommunication: userValues?.communication.email,
    phoneCommunication: userValues?.communication.phone,
    smsGateway: userValues?.defaultGateway?.sms,
    mmsGateway: userValues?.defaultGateway?.mms,
  }

  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const formik = useFormik<any>({
    initialValues,
    // validationSchema:role=="user"?profileDetailsSchema:staffprofileDetailsSchema,
    onSubmit: (values) => {
      setLoading(true)
      const formData = new FormData()
      if (role == 'user') {
        formData.append('companyName', values?.company)
        formData.append('companyWebsite', values?.companySite)
        formData.append('designation', 'Developer')
        formData.append('gender', 'Male')
        formData.append('language', values?.language)
        formData.append('firstName', values?.firstName)
        formData.append('lastName', values?.lastName)
        formData.append('timeZone', values?.timeZone)
        formData.append('currency', values?.currency)
        formData.append('emailCommunication', values?.emailCommunication)
        formData.append('phoneCommunication', values?.phoneCommunication)
        formData.append('allowMarketing', values?.allowMarketing)
        formData.append('country', values?.country)
        formData.append('avatar', values?.avatar)
        formData.append('smsGateway', values?.smsGateway)
        formData.append('mmsGateway', values?.mmsGateway)
      } else {
        formData.append('mobile', values?.mobile)
        formData.append('firstName', values?.firstName)
        formData.append('lastName', values?.lastName)
        formData.append('avatar', avatar)
      }
      formData.append('isReadFirstMessageApproval', 'true')

      dispatch(fetchAsyncupdateProfileDetails(formData)).then((res: any) => {
        dispatch(fetchAsyncUserDetails())
      })

      setLoading(false)
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0 fs-2'>Profile Details</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-form-label fw-bold fs-6'>Avatar</label>
              {/* <div className='col-lg-8'> */}
              <div className='image-input image-input-outline w-auto' data-kt-image-input='true'>
                {typeof avatar !== 'object' ? (
                  <img
                    src={avatar === '' || avatar === 'undefined' ? toAbsoluteUrl('/media/avatars/blank.png') : avatar}
                    alt='poster'
                    width={125}
                    height={125}
                  />
                ) : (
                  <img src={URL.createObjectURL(avatar)} alt='poster' width={125} height={125} />
                )}

                <label
                  className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                  data-kt-image-input-action='change'
                  data-bs-toggle='tooltip'
                  data-bs-dismiss='click'
                  title='Change avatar'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    fill='currentColor'
                    className='bi bi-pencil-fill'
                    viewBox='0 0 16 16'
                  >
                    <path d='M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z' />
                  </svg>
                  <input
                    type='file'
                    name='avtar'
                    onChange={(e: any) => setAvatar(e.target.files[0])}
                    accept='.png, .jpg, .jpeg'
                  />
                </label>

                <span
                  className='btn btn-icon btn-circle btn-color btn-active-color-primary w-25px h-25px bg-body shadow'
                  data-kt-image-input-action='remove'
                  data-bs-toggle='tooltip'
                  data-bs-dismiss='click'
                  title='Remove avatar'
                  onClick={() => setAvatar(defaultimage)}
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='25'
                    height='25'
                    fill='currentColor'
                    className='bi bi-x'
                    viewBox='0 0 16 16'
                  >
                    <path d='M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z' />
                  </svg>
                </span>
              </div>
              {/* </div> */}
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>Full Name</label>

              <div className='col-lg-8'>
                <div className='row'>
                  <div className='col-lg-6 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      placeholder='Full Name'
                      {...formik.getFieldProps('firstName')}
                    />
                    {formik.touched.firstName && formik.errors.firstName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.firstName}</div>
                      </div>
                    )}
                  </div>

                  <div className='col-lg-6 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Last name'
                      {...formik.getFieldProps('lastName')}
                    />
                    {formik.touched.lastName && formik.errors.lastName && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.lastName}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Contact Phone</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='tel'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Phone number'
                  {...formik.getFieldProps('contactPhone')}
                />
                {formik.touched.contactPhone && formik.errors.contactPhone && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block text-danger'>{formik.errors.contactPhone}</div>
                  </div>
                )}
              </div>
            </div>

            {/* />>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}

            {role == 'user' && (
              <>
                {' '}
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Company</label>

                  <div className='col-lg-8 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Company name'
                      {...formik.getFieldProps('company')}
                    />
                    {formik.touched.company && formik.errors.company && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.company}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Company Site</span>
                  </label>

                  <div className='col-lg-8 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Company website'
                      {...formik.getFieldProps('companySite')}
                    />
                    {formik.touched.companySite && formik.errors.companySite && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.companySite}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>Country</span>
                  </label>

                  <div className='col-lg-8 fv-row'>
                    <select
                      className='form-select form-select-solid form-select-lg fw-bold'
                      {...formik.getFieldProps('country')}
                    >
                      <option value=''>Select a Country...</option>
                      {/* {countries?.map((country: any,id:number) => (
                    <option key={id} value={country.value}>{country.label}</option>
                  ))} */}
                    </select>
                    {formik.touched.country && formik.errors.country && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.country}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Language</label>
                  <div className='col-lg-8 fv-row'>
                    <select
                      className='form-select form-select-solid form-select-lg'
                      {...formik.getFieldProps('language')}
                    >
                      <option value=''>Select a Language...</option>
                      <option value='en'>English</option>
                      {/* need this code */}
                      {/* <option value='en-gb'>English UK - British English</option> */}
                    </select>
                    {formik.touched.language && formik.errors.language && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.language}</div>
                      </div>
                    )}

                    <div className='form-text'>
                      Please select a preferred language, including date, time, and number
                      formatting.
                    </div>
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Time Zone</label>
                  <div className='col-lg-8 fv-row'>
                    <select
                      className='form-select form-select-solid form-select-lg'
                      {...formik.getFieldProps('timeZone')}
                    >
                      <option value=''>Select a Timezone..</option>
                      {/* {timeZone?.map((timezone: any,id:number) => (
                    <option key={id} value='International Date Line West'>{timezone.label} </option>
                  ))} */}
                    </select>
                    {formik.touched.timeZone && formik.errors.timeZone && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.timeZone}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>Currency</label>

                  <div className='col-lg-8 fv-row'>
                    <select
                      className='form-select form-select-solid form-select-lg'
                      {...formik.getFieldProps('currency')}
                    >
                      <option value=''>Select a currency..</option>
                      {Currency.map((item: any, id: number) => (
                        <option key={id} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                    {formik.touched.currency && formik.errors.currency && (
                      <div className='fv-plugins-message-container'>
                        <div className='fv-help-block text-danger'>{formik.errors.currency}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='row mb-6'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Communication</label>

                  <div className='col-lg-8 fv-row'>
                    <div className='d-flex align-items-center mt-3'>
                      <label className='form-check form-check-inline form-check-solid me-5'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          defaultChecked={userValues.communication.email}
                          {...formik.getFieldProps('emailCommunication')}
                        />
                        <span className='fw-bold ps-2 fs-6'>Email</span>
                      </label>

                      <label className='form-check form-check-inline form-check-solid'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          defaultChecked={userValues.communication.phone}
                          {...formik.getFieldProps('phoneCommunication')}
                        />
                        <span className='fw-bold ps-2 fs-6'>Phone</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className='row mb-0'>
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>Allow Marketing</label>

                  <div className='col-lg-8 d-flex align-items-center'>
                    <div className='form-check form-check-solid form-switch fv-row'>
                      <input
                        className='form-check-input w-45px h-30px'
                        type='checkbox'
                        id='allowmarketing'
                        defaultChecked={userValues.allowMarketing}
                        {...formik.getFieldProps('allowMarketing')}
                      />
                      <label className='form-check-label'></label>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button className='btn btn-white btn-active-light-primary me-2'>Discard</button>
            <button type='submit' className='btn btn-primary'>
              {!loading && 'Save Changes'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export {ProfileDetails}
